module.exports = __webpack_public_path__ + "img/page_image_2_7.7722b8ce.svg";